// Whether a start-scheduling click can be taken back.
//
// Starting outreach on the wrong recall row is noticed immediately, at the
// calendar, by whoever clicked — so the way back belongs there rather than six
// steps away in the task modal.

export interface StartSchedulingResponse {
  success?: boolean;
  taskId?: string;
  /** True when an open task already existed and was handed back. */
  existing?: boolean;
}

/**
 * The task this click created, or null if it created nothing.
 *
 * `existing: true` means the endpoint handed back a task somebody had already
 * started. Undoing that would delete their work under a button claiming to
 * undo a click that did nothing — so anything other than a freshly created
 * task is refused, including a response whose shape we do not recognise.
 */
export function undoableTaskFrom(
  response: StartSchedulingResponse | null | undefined,
): string | null {
  if (!response) return null;
  if (response.success !== true) return null;
  if (response.existing !== false) return null;
  return response.taskId || null;
}
